import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DescriptionIcon from '@material-ui/icons/Description';
import { CodeSnippet } from '@backstage/core-components';

const useStyles = makeStyles(
  (theme) => createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    entity: {
      overflow: "scroll",
      width: "100%"
    },
    codeBox: {
      border: "1px solid black",
      padding: "1em"
    }
  })
);
const EntityDialog = ({ entity }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const openDialog = () => {
    setOpen(true);
  };
  const closeDialog = () => {
    setOpen(false);
  };
  const dialogContent = () => {
    return /* @__PURE__ */ jsx(
      CodeSnippet,
      {
        language: "json",
        showLineNumbers: true,
        text: JSON.stringify(entity, null, 4)
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IconButton, { color: "primary", onClick: openDialog, children: /* @__PURE__ */ jsx(DescriptionIcon, {}) }),
    /* @__PURE__ */ jsxs(Dialog, { fullWidth: true, open, onClose: closeDialog, children: [
      /* @__PURE__ */ jsx(DialogTitle, { id: "dialog-title", children: /* @__PURE__ */ jsx(
        IconButton,
        {
          "aria-label": "close",
          className: classes.closeButton,
          onClick: closeDialog,
          children: /* @__PURE__ */ jsx(CloseIcon, {})
        }
      ) }),
      /* @__PURE__ */ jsx(DialogContent, { children: dialogContent() })
    ] })
  ] });
};

export { EntityDialog };
//# sourceMappingURL=EntityDialog.esm.js.map
